import NFTCollectionContract from "src/contract-logic/logic/NFTCollectionContract";
import NFTCoreContract from "src/contract-logic/logic/NFTCoreContract";
import multiCall from "src/utils/multicall";

export default class CollectionQuery {
  static async fetchBasicCollections(collectionIds, isGroup = true) {
    let [collectionSetIds, collectionsMetadata, collectionsExp] = await Promise.all([
      multiCall(
        NFTCollectionContract.ABI,
        collectionIds.map((collectionId) => ({
          address: NFTCollectionContract.ADDRESS,
          name: "getCollectionSetId",
          params: [collectionId],
        }))
      ),
      multiCall(
        NFTCollectionContract.ABI,
        collectionIds.map((collectionId) => ({
          address: NFTCollectionContract.ADDRESS,
          name: "getCollectionMetadata",
          params: [collectionId],
        }))
      ),
      multiCall(
        NFTCollectionContract.ABI,
        collectionIds.map((collectionId) => ({
          address: NFTCollectionContract.ADDRESS,
          name: "getCollectionExperience",
          params: [collectionId],
        }))
      ),
    ]);
    collectionsExp = collectionsExp.flat();
    collectionsMetadata = collectionsMetadata
      .map(([components, tokenRarity], index) => ({
        armorTokenId: parseInt(components.armorTokenId),
        helmetTokenId: parseInt(components.helmetTokenId),
        shieldTokenId: parseInt(components.shieldTokenId),
        weaponTokenId: parseInt(components.swordTokenId),
        rarity: parseInt(tokenRarity),
        id: parseInt(collectionIds[index]),
        setId: parseInt(collectionSetIds[index]),
        exp: parseInt(collectionsExp[index]),
      }))
      .filter((item) => item.rarity >= 1);

    let normalCollections = collectionsMetadata.filter((item) => item.rarity <= 5);
    let specialCollections = collectionsMetadata.filter((item) => item.rarity > 5);
    // fetch special collections metadata
    let [tokenURIList] = await Promise.all([
      multiCall(
        NFTCollectionContract.ABI,
        specialCollections.map((item) => ({
          address: NFTCollectionContract.ADDRESS,
          name: "tokenURI",
          params: [item.id],
        }))
      ),
    ]);
    tokenURIList = tokenURIList.flat();
    specialCollections = specialCollections.map((item, idx) => ({
      ...item,
      metadataLink: tokenURIList[idx],
    }));
    if (isGroup) return { normalCollections, specialCollections };
    else return normalCollections.concat(specialCollections);
  }

  static async fetchNormalItems(armorTokenIds, helmetTokenIds, shieldTokenIds, weaponTokenIds) {
    let [armorTokensMetadata, helmetTokensMetadata, shieldTokensMetadata, weaponTokensMetadata] = await Promise.all([
      multiCall(
        NFTCoreContract.ABI,
        armorTokenIds.map((tokenId) => ({
          address: NFTCoreContract.ADDRESS,
          name: "getTokenMetadata",
          params: [tokenId],
        }))
      ),
      multiCall(
        NFTCoreContract.ABI,
        helmetTokenIds.map((tokenId) => ({
          address: NFTCoreContract.ADDRESS,
          name: "getTokenMetadata",
          params: [tokenId],
        }))
      ),
      multiCall(
        NFTCoreContract.ABI,
        shieldTokenIds.map((tokenId) => ({
          address: NFTCoreContract.ADDRESS,
          name: "getTokenMetadata",
          params: [tokenId],
        }))
      ),
      multiCall(
        NFTCoreContract.ABI,
        weaponTokenIds.map((tokenId) => ({
          address: NFTCoreContract.ADDRESS,
          name: "getTokenMetadata",
          params: [tokenId],
        }))
      ),
    ]);
    armorTokensMetadata = armorTokensMetadata.flat();
    helmetTokensMetadata = helmetTokensMetadata.flat();
    shieldTokensMetadata = shieldTokensMetadata.flat();
    weaponTokensMetadata = weaponTokensMetadata.flat();
    const collections = [];
    for (let i = 0; i < armorTokenIds.length; i++) {
      collections[i] = {
        armor: {
          tokenId: parseInt(armorTokenIds[i]),
          rarity: parseInt(armorTokensMetadata[i].tokenRarity),
          exp: parseInt(armorTokensMetadata[i].experiencePoint),
        },
        helmet: {
          tokenId: parseInt(helmetTokenIds[i]),
          rarity: parseInt(helmetTokensMetadata[i].tokenRarity),
          exp: parseInt(helmetTokensMetadata[i].experiencePoint),
        },
        shield: {
          tokenId: parseInt(shieldTokenIds[i]),
          rarity: parseInt(shieldTokensMetadata[i].tokenRarity),
          exp: parseInt(shieldTokensMetadata[i].experiencePoint),
        },
        weapon: {
          tokenId: parseInt(weaponTokenIds[i]),
          rarity: parseInt(weaponTokensMetadata[i].tokenRarity),
          exp: parseInt(weaponTokensMetadata[i].experiencePoint),
        },
      };
    }
    return collections;
  }
}
